import { Link } from 'react-router-dom';

import { dateFormat } from 'common/helpers/dateHelper';
import { currencyFormat } from 'common/helpers/numberHelper';
import { phoneFormat } from 'common/helpers/phoneHelper';

const OrderRow = (props) => {
  const { order, settings } = props;
  return (
    <div className="c7-account__order">
      <div>{dateFormat(order.orderSubmittedDate, settings)}</div>

      <div>
        <strong>Order No.</strong>
        <br />
        {order.orderNumber}
      </div>

      {renderShipTo(order)}

      {renderStatus(order)}

      <div>
        <strong>{currencyFormat(order.total, settings)}</strong>
      </div>

      <div>
        <Link
          to={`/profile/order-history/${order.id}`}
          className="c7-button-alt-small"
        >
          {' '}
          View details
        </Link>
      </div>
    </div>
  );
};

export default OrderRow;

const renderShipTo = (order) => {
  if (order.orderDeliveryMethod === 'Carry Out') {
    return (
      <div>
        <strong>Carry out</strong>
      </div>
    );
  }

  if (order.orderDeliveryMethod === 'Pickup') {
    return (
      <div>
        <strong>Pickup</strong>
        <br />
        {order.pickupBy.firstName} {order.pickupBy.lastName}
        <br />
        Ph: {phoneFormat(order.pickupBy.phone, order.pickupBy.countryCode)}
      </div>
    );
  }
  return (
    <div>
      <strong>Ship to</strong>
      <br />
      {order.shipTo.firstName} {order.shipTo.lastName}
      <br />
      {order.shipTo.address}
    </div>
  );
};

const renderStatus = (order) => {
  if (order.paymentStatus !== 'Paid') {
    return (
      <div>
        <strong>Payment</strong>
        <br />
        {order.paymentStatus}
      </div>
    );
  }
  return (
    <div>
      <strong>Fulfillment</strong>
      <br />
      {order.fulfillmentStatus}
    </div>
  );
};
